import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=d2f3f8e2&"
import script from "./ValidationMessage.vue?vue&type=script&lang=js&"
export * from "./ValidationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ValidationMessage.vue?vue&type=style&index=0&id=d2f3f8e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports